export const ALLMOVIES = "ALLMOVIES";
export const MOVIEAPI =
  "https://api.themoviedb.org/3/movie/popular?api_key=ffcb86e2fb141a342f762e30f20a88b8";
